/**
 * Dictionnaire des élements d'affichages de layout
 */
export default new (/** @class */ (function () {
    function LayoutComponentsDictionary() {
        this.dictionary = new Map();
    }
    /**
     * Enregistrer un élément dans le dictionnaire
     * @param {string} nom. Nom du layout: field, tab, layout-columns, ...
     * @param {ComponentClass} component
     */
    LayoutComponentsDictionary.prototype.registerLayoutComponent = function (name, component) {
        this.dictionary.set(name, component);
        return true;
    };
    /**
     * Tester si le dictionnaire dispose d'un élement nommé
     *
     * @param {string} name
     * @returns true si l'élément est déjà enregistré dans le dictionnaire
     */
    LayoutComponentsDictionary.prototype.hasLayoutComponent = function (name) {
        return this.dictionary.has(name);
    };
    /**
     * Obtenir le composant enregistré dans le dictionnaire
     *
     * @param type
     * @param field
     *
     * @returns Le composant de l'élément d'affichage
     */
    LayoutComponentsDictionary.prototype.getLayoutComponent = function (name) {
        if (!this.hasLayoutComponent(name)) {
            return undefined;
        }
        return this.dictionary.get(name);
    };
    return LayoutComponentsDictionary;
}()))();
